// Menu Slide Bar js Start


$("body").on('click', '.gk-header__item', function (e) {
    if ($(e.target).closest(".gk-header__sub-item").length > 0 || $(e.target).closest(".gk-header__sub-link").length > 0  || $(e.target).hasClass("gk-header__sub-link") || $(e.target).hasClass("gk-header__sub-item")) {
        return;
    }

    e.preventDefault();
    const navLinks = document.querySelector(".gk-header__nav-links");
    navLinks.style.left = "-100%";
    var href = $(this).find('a').attr('href');
    window.location.href = href;
});

document.addEventListener("DOMContentLoaded", () => {
    if(document.querySelector('.gk-header') != null) {
    const navbar = document.querySelector(".gk-header__nav-container");
    const searchIcons = document.querySelectorAll(".gk-header__search-icons img"); // TODO check this
    const navLinks = document.querySelector(".gk-header__nav-links");
    const menuOpenBtn = document.querySelector(".gk-header__menu-icon");
    const menuCloseBtn = document.querySelector(".gk-header__close-icon");
    const htmlcssArrow = document.querySelector(".gk-header__arrow");
    const jsArrow = document.querySelector(".gk-header__arrow");

     // Search-box open/close functionality
     searchIcons.forEach(icon => {
        icon.addEventListener("click", (event) => {
            navbar.classList.toggle("showInput");
            searchIcons.forEach(otherIcon => {
                if (otherIcon !== icon) {
                    otherIcon.classList.toggle("gk-header__search-icon--active", navbar.classList.contains("showInput"));
                }
            });
            event.stopPropagation();
        });
    });

    // Close search bar when clicking outside
    document.addEventListener("click", (event) => {
        if (!navbar.contains(event.target)) {
            navbar.classList.remove("showInput");
            searchIcons.forEach(icon => {
                icon.classList.remove("gk-header__search-icon--active");
            });
        }
    });

    // Sidebar open/close functionality
    menuOpenBtn.addEventListener("click", () => {
        navLinks.style.left = "0";
    });

    menuCloseBtn.addEventListener("click", () => {
        navLinks.style.left = "-100%";
    });

    // Sidebar submenu open/close functionality
    // htmlcssArrow.addEventListener("click", () => {
    //     navLinks.classList.toggle("show1");
    // });

    // moreArrow.addEventListener("click", () => {
    //     navLinks.classList.toggle("show2");
    // });

    // jsArrow.addEventListener("click", () => {
    //     navLinks.classList.toggle("show3");
    // });
}
});


// Menu Slide Bar js End
document.addEventListener("DOMContentLoaded", () => {
    const subMenuLinks = document.querySelectorAll(".gk-header__item > .gk-header__link");

    subMenuLinks.forEach(link => {
        link.addEventListener("click", (event) => {
            if (window.innerWidth <= 991) {
                const subMenu = link.nextElementSibling;
                if (subMenu && subMenu.classList.contains("gk-header__sub-menu")) {
                    // Close other submenus
                    document.querySelectorAll(".gk-header__sub-menu.open").forEach(menu => {
                        if (menu !== subMenu) {
                            menu.classList.remove("open");
                            menu.previousElementSibling.classList.remove("active");
                        }
                    });
                    // Toggle the clicked submenu
                    if (subMenu.classList.contains("open")) {
                        subMenu.classList.remove("open");
                        link.classList.remove("active");
                    } else {
                        subMenu.classList.add("open");
                        link.classList.add("active");
                    }
                    event.preventDefault();
                }
            }
        });
    });

    // Close the submenu if clicked outside
    document.addEventListener("click", (event) => {
        if (window.innerWidth <= 991) {
            const target = event.target;
            if (!target.closest(".gk-header__item")) {
                document.querySelectorAll(".gk-header__sub-menu.open").forEach(menu => {
                    menu.classList.remove("open");
                    menu.previousElementSibling.classList.remove("active");
                });
            }
        }
    });
});



/* ===================== Gk Usp slider Start ================================ */
$(function () {
    const USP_slider = new Swiper('.js-gk-usp-slider', {
        slidesPerView: 'auto',
        loop: false,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        }, 
        breakpoints: {
            0: {
                slidesPerView: 1,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true,
                },
            },
            768: {
                slidesPerView: 2,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true,
                },
            },
            1024: {
                slidesPerView: 4,
                autoplay: false,
            }
        }
    });
});
/* ===================== Gk Usp slider Start ================================ */



/* ===================== Gk Partener slider Start ================================ */
$(function () {
    const partner_slider = new Swiper('.js-gk-partener-slider', {
        slidesPerView: 5,
        loop: true,
        lazy: {
            loadPrevNext: true,
        },
        breakpoints: {
            1024: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 5,
            },
            640: {
                slidesPerView: 4,
            },
            320: {
                slidesPerView: 4,
            }
        }
    });
});
/* ===================== Gk Partener slider Start ================================ */

/* ===================== Gk Partener slider Desktop Custom js Start ================================ */
// $(document).ready(function() {
//     // Add unique IDs to each chat box
//     $('.gk-partener__desktop-item').each(function(index) {
//         $(this).find('.gk-partener__desktop-chat-box').attr('id', 'chat-box-desktop-' + index);
//     });

//     $('.gk-partener__desktop-item').hover(function() {
//         // Hide all chat boxes
//         $('body').find('.gk-partener__desktop-chat-box').hide();

//         var $chatBox = $(this).find('.gk-partener__desktop-chat-box');
//         var parentOffset = $(this).offset();
//         var parentHeight = $(this).outerHeight();
        
//         // Get the unique ID of the current chat box
//         var chatBoxIdDesktop = $chatBox.attr('id');

//         // Show the current chat box and position it
//         $chatBox.css({
//             display: 'block',
//             top: parentOffset.top + parentHeight - 250 + 'px', // Position below the parent element
//             left: parentOffset.left + 50 + 'px', // Align with the parent element
//             opacity: '1',
//             bottom: 'unset'
//         }).appendTo('body'); // Append to body to escape the overflow hidden

//         // Store the ID in the element's data attribute for later use
//         $(this).data('chatBoxIdDesktop', chatBoxIdDesktop);
//     }, function() {
//         // Get the stored ID
//         var chatBoxIdDesktop = $(this).data('chatBoxIdDesktop');
        
//         // Hide the chat box using the stored ID
//         $('#' + chatBoxIdDesktop).hide().appendTo(this); // Hide and move back to parent
//     });
// });

$(document).ready(function() {
    // Add unique IDs to each chat box (Desktop Version)
    $('.gk-partener__desktop-item').each(function(index) {
        $(this).find('.gk-partener__desktop-chat-box').attr('id', 'chat-box-desktop-' + index);
    });

    $('.gk-partener__desktop-item').hover(function() {
        // Hide all chat boxes
        $('body').find('.gk-partener__desktop-chat-box').hide();

        var $chatBox = $(this).find('.gk-partener__desktop-chat-box');
        var parentOffset = $(this).offset();
        var parentHeight = $(this).outerHeight();
        
        // Get the unique ID of the current chat box
        var chatBoxIdDesktop = $chatBox.attr('id');

        // Show the current chat box and position it
        $chatBox.css({
            display: 'block',
            top: parentOffset.top + parentHeight - 250 + 'px', // Position below the parent element
            left: parentOffset.left + 50 + 'px', // Align with the parent element
            opacity: '1',
            bottom: 'unset'
        }).appendTo('body'); // Append to body to escape the overflow hidden

        // Store the ID in the element's data attribute for later use
        $(this).data('chatBoxIdDesktop', chatBoxIdDesktop);
    }, function() {
        // Get the stored ID
        var chatBoxIdDesktop = $(this).data('chatBoxIdDesktop');
        
        // Hide the chat box using the stored ID
        $('#' + chatBoxIdDesktop).hide().appendTo(this); // Hide and move back to parent
    });
});
/* ===================== Gk Partener slider Desktop Custom js Start ================================ */





/* ===================== Gk Partener slider Mobile Custom js Start ================================ */
$(function () {
    // Show the corresponding chat box on hover (Mobile Version)
    $('.gk-partener__item').hover(function() {
        const index = $(this).data('mobile-index');
        const chatBox = $(`#chat-box-${index}`);
        $('.gk-partener__chat-box').css('opacity', 0).hide();
        chatBox.css('opacity', 1).show();
    }, function() {
        const index = $(this).data('mobile-index');
        const chatBox = $(`#chat-box-${index}`);
        chatBox.css('opacity', 0).hide();
    });
});
/* ===================== Gk Partener slider Mobile Custom js Start ================================ */




/* ===================== Gk Best Sellers js Start ================================ */
const sellers_swiper = new Swiper('.js-gk-best-sellers', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    preloadImages: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    lazy: true,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return `<span class="${className}"></span>`;
        },
    },
    breakpoints: {
        // Customize breakpoints as per your requirement
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 40,
        }
    }
});
/* ===================== Gk Best Sellers js End ================================ */

/* ===================== Gk Best Sellers js Start ================================ */
$(document).ready(function() {
    const swiperInstance = new Swiper('.js-gk-ordinary', {
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}"></span>`;
            },
        },
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            991: {
                slidesPerView: 1,
                spaceBetween: 20,
            }
        }
    });    
});

/* ===================== Gk Best Sellers js End ================================ */
$(document).ready(function() { 
    var swiperReviws = new Swiper(".js-gk-reviews-slide", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        // spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            // Default settings for larger screens
            1200: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
        },
    });
});

/* ===================== Gk Best Delish Dishes js Start ================================ */
const bestSellersSwiper  = new Swiper('.js-gk-best-delish-dishes', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    preloadImages: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop: true,
    lazy: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return `<span class="${className}"></span>`;
        },
    },
    breakpoints: {
        // Customize breakpoints as per your requirement
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 24,
        }
    }
});
/* ===================== Gk Best Delish Dishes js Start ================================ */



/* ===================== Gk Cooked Video section js Start ================================ */
// const video = document.getElementById("video");
// const circlePlayButton = document.getElementById("gk-play-svg");
// const videoWrapper = document.getElementById("js-gk-video-wrapper");

// function togglePlay() {
//     if (video.paused || video.ended) {
//         video.play();
//     } else {
//         video.pause();
//     }
// }

// videoWrapper.addEventListener("click", togglePlay);

// video.addEventListener("playing", function () {
//     circlePlayButton.style.opacity = 0;
// });

// video.addEventListener("pause", function () {
//     circlePlayButton.style.opacity = 1;
// });
/* ===================== Gk Cooked Video section js End ================================ */




/* ===================== Gk Testimonial video play pause accordian start section js Start ================================ */
$(document).ready(function() {
    var playButtons = $('.js-gk-testimonial-media-btn');
    var allVideos = $('.gk-testimonial__media video');
    var currentlyPlayingVideo = null;

    function pauseAllVideos() {
        allVideos.each(function() {
            var video = $(this)[0]; // Get the raw DOM element
            if (!video.paused) {
                video.pause();
                var svgIcon = $(video).closest('.gk-testimonial__media').find('.js-gk-testimonial-media-btn');
                if (svgIcon) $(svgIcon).css('display', 'block');
                video.load();
            }
        });
    }

    function playVideo(video, playButton) {
        pauseAllVideos();
        video.play();
        if (playButton) $(playButton).css('display', 'none');
        currentlyPlayingVideo = video;
    }

    playButtons.each(function() {
        var playButton = $(this);
        var video = playButton.closest('.gk-testimonial__media').find('video')[0]; // Get the raw DOM element

        playButton.on('click', function() {
            if (video.paused) {
                playVideo(video, playButton);
            } else {
                video.pause();
                playButton.css('display', 'block');
                currentlyPlayingVideo = null;
            }
        });

        $(video).on('click', function() {
            if (video.paused) {
                playVideo(video, playButton);
            } else {
                video.pause();
                playButton.css('display', 'block');
                currentlyPlayingVideo = null;
            }
        });

        $(video).on('ended', function() {
            playButton.css('display', 'block');
            setTimeout(function() {
                video.load();
            }, 100);
            currentlyPlayingVideo = null;
        });
    });
});
/* ===================== Gk Testimonial video play pause accordian start section js Start ================================ */


/* ===================== Gk Testimonial section js Start ================================ */
var testimonialSlider = new Swiper(".js-gk-testimonial-slider", {
    effect: "coverflow",
    grabCursor: false,
    simulateTouch: false,
    allowTouchMove: false,
    centeredSlides: true,
    slidesPerView: "auto",
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 80,
      modifier: 2.4,
      slideShadows: true
    },
    keyboard: {
      enabled: true
    },  
    spaceBetween: 80,
    loop: true,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true
    // },
    breakpoints: {
        // when window width is <= 360px
        360: {
            spaceBetween: 30,
            coverflowEffect: {
                stretch: 0,
                depth: 80,
                modifier: 2
            }
        },
        // when window width is <= 768px
        768: {
            spaceBetween: 50,
            coverflowEffect: {
                depth: 80,
                modifier: 2
            }
        }
    },
    lazy: {
        loadPrevNext: true, // Load adjacent slides
        loadPrevNextAmount: 8
    },
});
testimonialSlider.on('slideChange', function () {
    const videos = document.querySelectorAll('.swiper-slide video');
      
    // Loop through the videos and pause them
    videos.forEach(video => {
      if (!video.paused) {
        video.pause();
        $('.js-gk-testimonial-media-btn').show();
      }
    });
});
/* ===================== Gk Testimonial section js End ================================ */


/* ===================== Gk faq-accoridan section js Start ================================ */
$(".js-gk-faq-accoridan").click(function (e) {
    e.preventDefault();
    let accordionItem = $(this);
    accordionItem.next().hasClass("is--visible") ? (accordionItem.next().removeClass("is--visible"), accordionItem.next().slideUp(350)) : (accordionItem.parent().parent().find(".js-accoridan-faq").removeClass("is--visible"), accordionItem.parent().parent().find(".js-accoridan-faq").slideUp(350), accordionItem.next().toggleClass("is--visible"), accordionItem.next().slideToggle(350))

    $(this).parent().siblings().removeClass("js-active"), $(this).parent().toggleClass("js-active");
});
// $(".js-gk-faq-accoridan").on("click", function (e) {
//     $(this).parent().siblings().removeClass("js-active"), $(this).parent().toggleClass("js-active");
// });
/* ===================== Gk faq-accoridan section js End ================================ */


/* ===================== Gk Gallery Slider section js Start ================================ */
// var slider = new Swiper ('.js-gk-gallery-slider', {
//     slidesPerView: 1,
//     centeredSlides: false,
//     preloadImages: false,
//     loop: true,
//     lazy: true,
//     loopedSlides: 6,
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
// });

// var thumbs = new Swiper ('.js-gk-gallery-thumbs', {
//     slidesPerView: 'auto',
//     spaceBetween: 10,
//     centeredSlides: false,
//     preloadImages: false,
//     loop: true,
//     lazy: true,
//     slideToClickedSlide: true,
//     breakpoints: {
//         // when window width is <= 768px
//         768: {
//             slidesPerView: 5,
//             spaceBetween: 10
//         }
//         // you can add more breakpoints for different screen sizes if needed
//     }
// });

var swiper_thumb = new Swiper(".js-gk-gallery-thumbs", {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true, 
    watchOverflow: true,
    loopAdditionalSlides: 1,
    direction: "vertical"
  });

  var swiper2 = new Swiper(".js-gk-gallery-slider", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper_thumb,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    }
  });

/* ===================== Gk Gallery Slider section js Start ================================ */

/* format money */
function formatMoney(e, t) {
    typeof e == "string" && (e = e.replace(".", ""));
    var i2 = ""
      , s = /\{\{\s*(\w+)\s*\}\}/
      , n = t || "${{amount}}";
    function r(e2, t2, i3, s2) {
        if (i3 = i3 || ",",
        s2 = s2 || ".",
        isNaN(e2) || e2 === null)
            return 0;
        var n2 = (e2 = (e2 / 100).toFixed(t2)).split(".");
        return n2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i3) + (n2[1] ? s2 + n2[1] : "")
    }
    switch (n.match(s)[1]) {
    case "amount":
        i2 = r(e, 2);
        break;
    case "amount_no_decimals":
        i2 = r(e, 0);
        break;
    case "amount_with_comma_separator":
        i2 = r(e, 2, ".", ",");
        break;
    case "amount_no_decimals_with_comma_separator":
        i2 = r(e, 0, ".", ",");
        break;
    case "amount_no_decimals_with_space_separator":
        i2 = r(e, 0, " ");
        break;
    case "amount_with_apostrophe_separator":
        i2 = r(e, 2, "'")
    }
    return n.replace(s, i2)
}

/* ===================== Gk Product Active Plan section js Start ================================ */
$(document).ready(function() {
    const $cards = $('.gk-product-active-plan__card');

    // Ensure the first checkbox is checked and its label is displayed by default
    const $firstCard = $cards.first();
    const $firstCheckbox = $firstCard.find('.gk-product-active-plan__checkbox');
    const $firstLabel = $firstCard.find('label');
    $firstCheckbox.prop('checked', true).trigger('change');
    $firstLabel.css('display', 'flex');

    $cards.on('click', function() {
        const $card = $(this);
        const $checkbox = $card.find('.gk-product-active-plan__checkbox');
        $checkbox.prop('checked', true).trigger('change');

        $cards.each(function() {
            const $c = $(this);
            const $label = $c.find('label');
            if ($c.is($card)) {
                $label.css('display', 'flex');
            } else {
                const $cb = $c.find('.gk-product-active-plan__checkbox');
                $cb.prop('checked', false);
                $label.css('display', 'none');
            }
        });
    });
});


$(document).ready(function() {
    const $cards = $('.gk-product-active-plan__card-subscribeplan');

    // Ensure the third checkbox is checked and its label is displayed by default
    const $thirdCard = $cards.eq(2); // Selects the third card
    const $thirdCheckbox = $thirdCard.find('.gk-product-active-plan__checkbox-sub');
    const $thirdLabel = $thirdCard.find('label');
    $thirdCheckbox.prop('checked', true).trigger('change');
    $thirdLabel.css('display', 'flex');

    $cards.on('click', function() {
        const $card = $(this);
        const $checkbox = $card.find('.gk-product-active-plan__checkbox-sub');
        $checkbox.prop('checked', true).trigger('change');

        $cards.each(function() {
            const $c = $(this);
            const $label = $c.find('label');
            if ($c.is($card)) {
                $label.css('display', 'flex');
            } else {
                const $cb = $c.find('.gk-product-active-plan__checkbox-sub');
                $cb.prop('checked', false);
                $label.css('display', 'none');
            }
        });
    });
});

/* ===================== Gk Product Active Plan section js Start ================================ */


/* ===================== Gk Product Purchase section js Start ================================ */
$(document).ready(function() {
    const $cards = $('.gk-product-purchase__card');

    // Ensure the first checkbox is checked and its label is displayed by default
    const $firstCard = $cards.first();
    const $firstCheckbox = $firstCard.find('.gk-product-purchase__checkbox');
    const $firstLabel = $firstCard.find('label');
    $firstCheckbox.prop('checked', true).trigger('change');
    // $firstLabel.css('display', 'flex');

    $cards.on('click', function() {
        const $card = $(this);
        const $checkbox = $card.find('.gk-product-purchase__checkbox');
        $checkbox.prop('checked', true).trigger('change');

        $cards.each(function() {
            const $c = $(this);
            const $label = $c.find('label');
            if ($c.is($card)) {
                // $label.css('display', 'flex');
            } else {
                const $cb = $c.find('.gk-product-purchase__checkbox');
                $cb.prop('checked', false);
                // $label.css('display', 'none');
            }
        });
    });


    $('body').on("change",'.variant_radio_change',function(e) {
        var form = $(this).closest('form');
        var product_info = $(this).closest('.gk_product');

        var all_varaint_data = JSON.parse(product_info.find('#product_variants').html());
        var current_id = $(this).val();
        var current_variant = all_varaint_data.find((x) => x.id == current_id);
        


        var moneyFormat = product_info.attr("data-moneyFormat");
        if(current_variant.compare_at_price != null &&  current_variant.compare_at_price > current_variant.price) {
            product_info.find('.gk-compare-price').html(formatMoney(current_variant.compare_at_price,moneyFormat)).removeClass('hidden');
        } else {
            product_info.find('.gk-compare-price').addClass('hidden');
        }
        product_info.find('.gk_regular_product_price').html(formatMoney(current_variant.price,moneyFormat));

        if(current_variant.selling_plan_allocations.length > 0 && product_info.find('.gk-product-purchase__subscribe').length > 0) {
            if(product_info.find('[name="purchase"]:checked').val() == 'selling_sub') {
                var current_selling_plan_active = current_variant.selling_plan_allocations.find((x) => product_info.find('[name="purchase"]:checked').closest('.selling_plan_id').attr("data-selling_plan_id") == x.selling_plan_id);
                product_info.find('.regular_product_price.gk_regular_product_price').html(formatMoney(current_selling_plan_active.price,moneyFormat));
            }

            $.each(current_variant.selling_plan_allocations, function(index, val){
                product_info.find('.selling_plan_id[data-selling_plan_id="'+val.selling_plan_id+'"]').find('.selling_plan_price').html(formatMoney(val.price,moneyFormat));
            });
        } 

    });


    $('body').on('change','[name="purchase"].gk-product-purchase__checkbox',function(e){
        if($(this).val() == 'selling_sub') {
            var selling_plan_id = $(this).attr("data-selling_plan_id");
            $(this).closest('form').find('input[name="selling_plan"]').val(selling_plan_id);
        } else {
            $(this).closest('form').find('input[name="selling_plan"]').val("");
        }   
        $(this).closest('form').find('input[name="id"]:checked').trigger("change");
    });

    $('body').on('change','.delivery_every_select',function(e){
        var selling_plan_id = $(this).val();
        $(this).closest('form').find('input[name="selling_plan"]').val(selling_plan_id);
        $(this).closest('.selling_plan_id').attr("data-selling_plan_id",selling_plan_id);
        $(this).closest('.selling_plan_id').find("[name='purchase']").attr("data-selling_plan_id",selling_plan_id);

        $(this).closest('form').find('input[name="id"]:checked').trigger("change");
    });

});

/* ===================== Gk Product Purchase section js Start ================================ */


/* ===================== Gk Product Details Accordion section js Start ================================ */
$("body").on("click",".js-product-details-accordion",function (e) {
    e.preventDefault();
    let accordionItem = $(this);
    accordionItem.next().hasClass("is--visible") ? (accordionItem.next().removeClass("is--visible"), accordionItem.next().slideUp(350)) : (accordionItem.parent().parent().find(".js-accoridan-faq").removeClass("is--visible"), accordionItem.parent().parent().find(".js-accoridan-faq").slideUp(350), accordionItem.next().toggleClass("is--visible"), accordionItem.next().slideToggle(350))
})
$("body").on("click",".js-product-details-accordion",function () {
    $(this).parent().siblings().removeClass("js-active"), $(this).parent().toggleClass("js-active")
})
/* ===================== Gk Product Details Accordion section js Start ================================ */



// ATC Code start
 

$(document).ready(function(){

    if($('.common-product-btn').length){
        $(document).on('click', '.common-product-btn', function(e){
            e.preventDefault();
            var $this = $(this);
            $this.find('.main_loader').addClass('show');
            
            var get_var_id = $(this).attr('data-varaint'); 
            var shipping_date = $(this).attr('data-shipping-date');
            var selling_plan = $(this).attr('data-selling-plan');

            
            var data = {
                "id": get_var_id,
                "quantity": 1
            };

            // Add properties only if shipping_date has a value
            if (shipping_date && shipping_date.trim() !== '') {
                data.properties = {
                    "Shipping Date": shipping_date
                };
            }

            if (selling_plan && selling_plan.trim() !== '') {
                data.selling_plan = selling_plan;
            }

            $.ajax({
                type: "POST",
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function(response) {
                    updateCartContent();
                    $.getJSON('/cart.js', function(cart) {                    
                        var total_qty= cart.item_count;
                                            
                        $(".cart-count-bubble span").text(total_qty);
                        var get_class = $(".cart-count-bubble").attr('class');
                        var new_class = 'cart-count-bubble cart-count-bubble--' + total_qty + ' ' + total_qty;                        
                        $("#cart_count_number").removeClass(get_class).addClass(new_class)
                        
                    });
                    $( ".header__icon.header__icon--cart" ).trigger( "click" );
                    $this.find('.main_loader').removeClass('show');
                },
                error: function (xhr, ajaxOptions, thrownError) {
                }      
            });  
        });
    }

    
    function updateCartContent({ onComplete } = {}) {
        refreshCartContentV2(onComplete);
        return false;        
    }

    $(window).scroll(function(){
        var total_height = '';
        if($('.gk-announcement-bar').length){
            var announce_height = $('.gk-announcement-bar').outerHeight();
            total_height = announce_height;
            if($('.gk-usp').length){
                var usp_height = $('.gk-usp').outerHeight();
                total_height = announce_height + usp_height;
            }
        }else{
            if($('.gk-usp').length){
                var usp_height = $('.gk-usp').outerHeight();
                total_height = usp_height;
            }
        }

        if ($(window).scrollTop() >= total_height) {
            $('.gk-header').addClass('fixed-header');
        }
        else {
            $('.gk-header').removeClass('fixed-header');
        }
    });
    
});


$(document).ready(function() {
    $('body').on("click",".custom_sort_sctive",function(e){
        e.preventDefault();
       if ($(this).closest('.display_custom_sort').find('.custom_select_drop_down').is(':visible')){
         $(this).closest('.display_custom_sort').find('.custom_select_drop_down').slideUp(300);
       }else{ 
        $(this).closest('.display_custom_sort').find('.custom_select_drop_down').slideDown(300);
       }
      });

 $('body').on("click",".gk-product .junip-product-summary-stars-wrapper",function(e){
    e.preventDefault();
    if($('.junip-review-section.junip-review-section-rendered').length > 0) {
        window.scrollTo(0,$('.junip-review-section.junip-review-section-rendered').offset().top - $('header').outerHeight() - 100, 1000);
    }
    });
});